module.exports = __webpack_public_path__ + "static/media/_somaliland.9b121b76.png";